import { doc } from "firebase/firestore";
import React from "react";
import { db } from "firebaseApp";
import { useDocumentData } from "react-firebase-hooks/firestore";
import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Skeleton,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import { useNavigate, useParams } from "react-router-dom";

export default function FriendListItem({ 
  friend,
  onSelect = () => {},
}) {

  const navigate = useNavigate();
  const theme = useTheme();

  const { friendId } = useParams(); 

  const [user, loading, error] = useDocumentData(
    doc(db, "userPublicProfiles", friend.friendId)
  );

  if (error) {
    console.log(error);
  }

  if (loading) {
    return (
      <ListItem key={friend.id}>
        <ListItemText
          primary={<Skeleton variant="text" />}
          secondary={<Skeleton variant="text" />}
        />
      </ListItem>
    );
  }

  const handleSelect = () => {
    navigate(`/talk/${friend.friendId}`);
    onSelect();
  }

  return (
    <ListItem
      selected={friendId === friend.friendId}
    >
      <ListItemButton
        onClick={handleSelect}
      >
        <ListItemAvatar>
          <Avatar alt={user.username} src={user.avatarUrl} />
        </ListItemAvatar>
        <ListItemText
          sx={{
            color: theme.palette.text.main,
          }}
        >
          {user.username}
        </ListItemText>
      </ListItemButton>
    </ListItem>
  );
}
